exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pagination__item[data-v-f4c9d5a0]{margin-left:8px;margin-right:8px;color:#343434}.pagination__item.current[data-v-f4c9d5a0]{color:#000;font-weight:800}#paginationInput[data-v-f4c9d5a0]{border:1px solid #D9D9D9;font-family:'Poppins';padding:6px;font-size:14px;text-align:center;width:16px;line-height:11px;height:16px;appearance:none;-webkit-appearance:none;-moz-appearance:textfield;margin:0 3px}#paginationInput[data-v-f4c9d5a0]::-webkit-outer-spin-button,#paginationInput[data-v-f4c9d5a0]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}.next i[data-v-f4c9d5a0],.prev i[data-v-f4c9d5a0]{font-size:30px}\n", ""]);

// exports
